import './Sidenav.scss';

import React, { useState } from 'react';
import { faFacebookF, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderLogo1 from '../../images/droletLogo.svg';
import { LocalizedLink } from '../../../../gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { Sidenavmenu } from './';
import SiteLocaleSelectionPopupMenu from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/SiteLocale/SiteLocaleSelectionPopupMenu';
import { useBoutikService } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/boutikService/useBoutikService';
import { useLoginContext } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/login/useLoginContext';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function Sidenav(props: {
    action: any;
    accessories: Map<any, any>;
    ventings: Map<any, any>;
}) {
    const { t } = useTranslation('layout');
    const { accessories, ventings } = props;
    const [isApplianceOpen, setApplianceOpen] = useState(false);
    const [isVentingOpen, setVentingOpen] = useState(false);
    const [isAccessoryOpen, setAccessoryOpen] = useState(false);
    const [isSupportOpen, setSupportOpen] = useState(false);
    const { isAuthenticated } = useBoutikService();
    const { navigateTranslated } = usePageLocalization();
    const { setQuickLoginVisible } = useLoginContext();

    return (
        <div className='sidenav-mobile'>
            <div className='sidenav-head'>
                <div className='close'>
                    <FontAwesomeIcon
                        onClick={() => props.action()}
                        icon={faTimes}
                    />
                </div>
                <img
                    className='header-logo'
                    src={HeaderLogo1}
                    alt='Drolet Logo'
                />
            </div>

            <Sidenavmenu
                t={t}
                states={[
                    {
                        isOpen: isApplianceOpen,
                        setIsOpen: (value: boolean) => setApplianceOpen(value),
                    },
                    {
                        isOpen: isVentingOpen,
                        setIsOpen: (value: boolean) => setVentingOpen(value),
                    },
                    {
                        isOpen: isAccessoryOpen,
                        setIsOpen: (value: boolean) => setAccessoryOpen(value),
                    },
                    {
                        isOpen: false,
                        setIsOpen: (value: any) => undefined, //Necessaire vu que piece de remplacement n'est pas un dropdown
                    },
                    {
                        isOpen: isSupportOpen,
                        setIsOpen: (value: boolean) => setSupportOpen(value),
                    },
                ]}
                accessories={accessories}
                ventings={ventings}
            />
            <hr />

            <div className='sidenav-footer'>
                <div className='sidenav-foot'>
                    <FontAwesomeIcon className='account-icon' icon={faUser} />
                    <div
                        className='sidenav-foot-title'
                        onClick={() => {
                            if (isAuthenticated) {
                                navigateTranslated('/account/my-account/');
                            } else {
                                setQuickLoginVisible(true);
                            }
                            props?.action();
                        }}
                    >
                        {t('header.my-account')}
                    </div>
                </div>
                <div className='sidenav-foot'>
                    <LocalizedLink
                        className='sidenav-foot-title'
                        to='/where-to-buy/'
                        label={t('header.where-to-buy')}
                    />
                </div>
                <div className='sidenav-foot socials'>
                    <SiteLocaleSelectionPopupMenu showCurrency={true} />
                    <a
                        href='https://facebook.com'
                        target='_blank'
                        rel='noreferrer'
                    >
                        <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                    <a
                        href='https://youtube.com'
                        target='_blank'
                        rel='noreferrer'
                    >
                        <FontAwesomeIcon icon={faYoutube} />
                    </a>
                </div>
            </div>
        </div>
    );
}
